import { render, staticRenderFns } from "./deliveryAbort.vue?vue&type=template&id=40796536&scoped=true&"
import script from "./deliveryAbort.vue?vue&type=script&lang=js&"
export * from "./deliveryAbort.vue?vue&type=script&lang=js&"
import style0 from "./deliveryAbort.vue?vue&type=style&index=0&id=40796536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40796536",
  null
  
)

export default component.exports